import { render } from "./CaixaSelecao.vue?vue&type=template&id=5c2183af&scoped=true&ts=true"
import script from "./CaixaSelecao.vue?vue&type=script&lang=ts"
export * from "./CaixaSelecao.vue?vue&type=script&lang=ts"

import "./CaixaSelecao.vue?vue&type=style&index=0&id=5c2183af&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2183af"]])

export default __exports__